(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[907],{

/***/ 57808:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features",
      function () {
        return __webpack_require__(99448);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ features; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./pages/features/features.module.css
var features_module = __webpack_require__(21167);
var features_module_default = /*#__PURE__*/__webpack_require__.n(features_module);
// EXTERNAL MODULE: ./constants/constants.js
var constants = __webpack_require__(43138);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/FeaturesCards/index.jsx



const Cards = (param)=>{
    let { cardImgSrc , cardImgAlt , cardImgLoading ="lazy" , cardImgHidden =false , cardTagText1 , cardTagText2 , cardHeadingText1 , cardHeadingText2 , cardHeadingText3 , cardDescText1 , cardDescText2 , cardDescText3 , cardRowReverse =false , cardBtnText1 , cardBtnLink1 ="#" , cardBtnText2 , cardStyles , cardImgStyles , cardClassName ="" , cardImgFullWidth =false , cardDisplayTextSection =true  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: cardStyles,
        className: "".concat(cardClassName, " ").concat(cardRowReverse ? "md:flex-row-reverse" : "md:flex-row", " w-full max-w-7xl flex flex-col justify-center items-center mt-40"),
        children: [
            !cardImgHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                className: "w-full ".concat(cardImgFullWidth ? "md:w-3/4" : "md:w-1/2"),
                src: cardImgSrc,
                style: cardImgStyles,
                alt: cardImgAlt,
                loading: cardImgLoading,
                width: "500",
                height: "500"
            }),
            cardDisplayTextSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full mt-10 md:mt-0 md:w-1/2 flex justify-center items-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full sm:w-3/4",
                    children: [
                        cardTagText1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-center w-fit py-1 px-4 rounded-full font-medium text-white text-base md:text-lg mt-4 bg-[#915bff]",
                            children: cardTagText1
                        }),
                        cardTagText2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "w-fit py-1 rounded-full font-semibold text-2xl sm:text-3xl md:text-4xl mt-4 text-[#915bff]",
                            children: cardTagText2
                        }),
                        cardHeadingText1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-2xl sm:text-3xl md:text-4xl font-semibold mt-4 leading-[1.375!important]",
                            children: cardHeadingText1
                        }),
                        cardDescText1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-base md:text-lg mt-3",
                            children: cardDescText1
                        }),
                        cardHeadingText2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-2xl sm:text-3xl md:text-4xl font-semibold mt-10",
                            children: cardHeadingText2
                        }),
                        cardDescText2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-base md:text-lg mt-3",
                            children: cardDescText2
                        }),
                        cardHeadingText3 && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-2xl sm:text-3xl md:text-4xl font-semibold mt-4",
                            children: cardHeadingText3
                        }),
                        cardDescText3 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-base md:text-lg mt-3",
                            children: cardDescText3
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full flex flex-col lg:flex-row justify-start items-center gap-2 lg:gap-3 mt-5",
                            children: [
                                cardBtnText1 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    target: "_self",
                                    href: cardBtnLink1,
                                    className: "w-full lg:w-1/2 text-lg text-center font-semibold px-3 lg:px-4 py-2 border-2 border-[#915bff] rounded-lg text-[#915bff] hover:bg-[#a97dff] hover:text-white transition-colors",
                                    children: cardBtnText1
                                }),
                                cardBtnText2 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    target: "_",
                                    href: "https://approval-dashboard.boloforms.com/login",
                                    className: "w-full lg:w-1/2 text-lg text-center font-medium px-3 lg:px-4 py-2 rounded-lg bg-[#915bff] text-white hover:opacity-90 transition-colors",
                                    children: cardBtnText2
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var FeaturesCards = (Cards);

;// CONCATENATED MODULE: ./components/FeaturesBackground/index.jsx


const Background = (param)=>{
    let { bgImgSrc , bgContainerStyles , bgImgStyles , bgUpSideDown =false , bgClassNameContainer ="" , bgClassNameImg =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: bgContainerStyles,
        className: "".concat(bgClassNameContainer, " w-screen h-fit pointer-events-none translate-x-4 xs:translate-x-6 lg:translate-x-[88px] xxl:translate-x-[128px] -z-10 overflow-hidden absolute right-0 ").concat(bgUpSideDown ? "-top-1 rotate-180" : "bottom-0"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            style: bgImgStyles,
            className: "".concat(bgClassNameImg, " w-full h-full"),
            width: 10,
            height: 10,
            src: bgImgSrc,
            alt: "Background Shape"
        })
    });
};
/* harmony default export */ var FeaturesBackground = (Background);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/features/index.jsx







const Features = ()=>{
    const features = [
        {
            featuresContainerStyles: "flex-col-reverse md:flex-row mt-0",
            cardImgSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/1.png",
            cardImgAlt: "Features",
            cardImgLoading: "eager",
            cardTagText2: "FEATURES",
            cardHeadingText1: "Discover how BoloForms Approvals works.",
            cardDescText1: "Learn how to automate your approvals and transform your business.",
            cardBtnText2: "Try For Free!",
            cardClassName: "".concat((features_module_default()).section_1, " mt-[50px!important]"),
            bgImgSrc: "".concat(constants.BASE_ASSETS_URL, "/features/bg_1.svg"),
            bgContainerStyles: {
                bottom: "-300px"
            },
            bgClassNameContainer: "bottom-[-50px!important] sm:bottom-[-150px!important] lg:bottom-[-200px!important] xl:bottom-[-250px!important] xxl:bottom-[-350px!important]",
            bgImgStyles: {
                transform: "scaleX(-1)"
            }
        },
        {
            featuresContainerStyles: "mt-10 sm:mt-40",
            cardImgSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/2.png",
            cardImgAlt: "User-Friendly Approval Builder",
            cardTagText1: "Easy-to-Use Builder",
            cardHeadingText1: "User-Friendly Approval Builder",
            cardDescText1: "With BoloForms' intuitive & simple interface, you can easily enhance your approval workflow, add new approvers, send PDFs & set up tailored emails, and much more. In just a few clicks, you can create the ideal workflow for your business!",
            cardRowReverse: true,
            cardBtnText1: "Watch Video",
            cardBtnLink1: "https://www.youtube.com/watch?v=riiUkCRpIio&list=PL5JmkY7cOocwnLRcqWkQCjXpVWT780iq_",
            cardClassName: "mt-20 sm:mt-56",
            bgImgSrc: "".concat(constants.BASE_ASSETS_URL, "/features/bg_1.svg"),
            bgUpSideDown: true,
            bgContainerStyles: {
                top: "0px"
            },
            bgClassNameContainer: "top-[0px!important] sm:top-[-50px!important] lg:top-[0px!important] xxl:top-[100px!important]",
            bgImgStyles: {
                transform: "scaleX(-1)"
            }
        },
        {
            featuresContainerStyles: "flex-col mt-20 sm:mt-40",
            preCardJsx: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full flex flex-col justify-center items-center mt-16 md:mt-0 lg:mt-10 xl:mt-32 min-[1700px]:mt-52",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-xl md:text-3xl xl:text-4xl text-white text-center font-semibold mt-0 sm:mt-4",
                        children: "Select the Optimal Approval Approach for Your Requirements"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-base md:text-lg mt-3 text-white text-center w-full ",
                        children: "Utilize Approve & Sign to collect e-signatures and other approval actions from your colleagues."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        target: "_blank",
                        href: "https://approval-dashboard.boloforms.com/login",
                        className: "w-1/2 md:w-fit text-base sm:text-lg text-center font-medium px-6 py-1 sm:py-2 rounded-lg bg-white text-[#915bff] hover:opacity-90 transition-colors mt-3 lg:mt-10",
                        children: "Try for Free"
                    })
                ]
            }),
            cardImgSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/3.png",
            cardImgAlt: "Approval process",
            cardStyles: {
                marginTop: "0px"
            },
            cardImgStyles: {
                transform: "scale(0.8)"
            },
            cardImgFullWidth: true,
            cardDisplayTextSection: false,
            bgImgSrc: "".concat(constants.BASE_ASSETS_URL, "/features/bg_2.svg"),
            bgContainerStyles: {
                top: "-100px"
            },
            bgImgStyles: {
                transform: "scaleX(-1)"
            },
            bgClassNameContainer: (features_module_default()).bg_container_1,
            bgClassNameImg: (features_module_default()).bg_img_1
        },
        {
            featuresContainerStyles: "flex-col mt-20",
            preCardJsx: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full flex flex-col justify-center items-center mt-16 sm:mt-32 md:mt-10 lg:mt-16 xl:mt-32 xxl:mt-44 min-[1700px]:mt-60 mb-40",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-2xl md:text-3xl xl:text-4xl text-white text-center font-semibold mt-4",
                        children: "Advanced Approval Settings"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-base md:text-lg mt-3 text-white text-center w-full ",
                        children: "Level up your approval flow with advanced settings options."
                    })
                ]
            }),
            // cardImgSrc: i4,
            cardImgAlt: "",
            cardImgHidden: true,
            // cardHeadingText1: "Custom Outcomes",
            // cardDescText1:
            //   "Approve or deny form submissions, or create your own custom outcomes — like adding respondents to a wait list, putting them on hold, or whatever else you choose.",
            // cardBtnText2: "Try For Free!",
            cardStyles: {
                marginTop: "0px"
            },
            // cardClassName: styles.card_mt_1,
            bgImgSrc: "".concat(constants.BASE_ASSETS_URL, "/features/bg_2.svg"),
            bgContainerStyles: {
                top: "-100px"
            },
            bgClassNameContainer: (features_module_default()).bg_container_1,
            bgClassNameImg: (features_module_default()).bg_img_1
        },
        // {
        //   featuresContainerStyles: "",
        //   cardImgSrc: i5,
        //   cardTagText1: "BoloForms Dashboard",
        //   cardHeadingText1: "Allow Comments",
        //   cardDescText1:
        //     "Enable users to input a comment when they approve or reject requests, allowing for more detailed feedback and facilitating communication between the requester and approver.",
        //     cardRowReverse: true,
        //   bgImgSrc: `${BASE_ASSETS_URL}/features/bg_3.svg`,
        //   bgContainerStyles: { top: "-50px" },
        //   bgImgStyles: {
        //     width: "45%",
        //     transform: "translateX(125%)",
        //     opacity: "0.15",
        //   },
        // },
        {
            featuresContainerStyles: "mt-0",
            cardImgSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/4.png",
            cardImgAlt: "E-Signature",
            cardTagText1: "E-Signature",
            cardHeadingText1: "Request e-Signature",
            cardDescText1: "Simplify your document signing process by automatically requesting electronic signatures for your documents, such as contracts, purchase orders, or invoices.",
            cardBtnText2: "Try For Free!",
            cardRowReverse: true,
            cardClassName: "mt-0 sm:mt-40",
            // bgImgSrc: `${BASE_ASSETS_URL}/features/bg_4.svg`,
            bgImgSrc: "".concat(constants.BASE_ASSETS_URL, "/features/bg_3.svg"),
            // bgContainerStyles: { top: "-100px", right: "0px" },
            bgContainerStyles: {
                top: "-50px"
            },
            bgImgStyles: {
                // width: "40%",
                width: "45%",
                // transform: "translateX(-10%)",
                transform: "translateX(125%)",
                opacity: "0.15"
            }
        },
        {
            featuresContainerStyles: "",
            cardImgSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/6.png",
            cardImgAlt: "Request more information",
            cardTagText1: "Requests",
            cardHeadingText1: "Request more information",
            cardDescText1: "In the event that a form entry is lacking essential information, approvers can effortlessly request the form filler the required information right inside the BoloForms Dashboard.",
            cardBtnText2: "Try For Free!",
            // cardRowReverse: true,
            bgImgSrc: "".concat(constants.BASE_ASSETS_URL, "/features/bg_4.svg"),
            //  bgImgSrc: bg3,
            bgContainerStyles: {
                top: "-100px",
                right: "0px"
            },
            //  bgContainerStyles: { top: "-50px" },
            bgImgStyles: {
                width: "40%",
                //  width: "45%",
                transform: "translateX(-10%)",
                //  transform: "translateX(125%)",
                opacity: "0.15"
            }
        },
        {
            featuresContainerStyles: "mt-28 sm:mt-52",
            cardImgSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/5.png",
            cardImgAlt: "Customization & Automation",
            cardTagText1: "Customization & Automation",
            cardHeadingText1: "Send Customized Notification Emails",
            cardDescText1: "Send notification emails tailored to the specific stages of your approval process.",
            cardHeadingText2: "Send reminder emails",
            cardDescText2: "Send automated reminder emails everyday or manually to approval workflow participants to remind them of their tasks.",
            cardClassName: "mt-0 sm:mt-48",
            cardRowReverse: true,
            bgImgSrc: "".concat(constants.BASE_ASSETS_URL, "/features/bg_6.svg"),
            bgContainerStyles: {
                top: "-100px",
                right: "0px"
            }
        },
        // {
        //   featuresContainerStyles: "mt-52",
        //   cardImgSrc: i9,
        //   cardTagText1: "Snooze",
        //   cardHeadingText1: "Snooze tasks",
        //   cardDescText1:
        //     "Approvers can put a pause on responding to requests by snoozing tasks in Jotform Inbox. An automated notification email will be sent once the snooze period is over.",
        //   cardBtnText2: "Try For Free!",
        //   cardRowReverse: true,
        //   cardStyles: { marginTop: "200px" },
        //   cardClassName: styles.card_mt_1,
        //   bgImgSrc: `${BASE_ASSETS_URL}/features/bg_6.svg`,
        //   bgContainerStyles: { top: "-100px", right: "0px" },
        // },
        {
            featuresContainerStyles: "flex-col-reverse md:flex-row",
            cardImgSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/7.png",
            cardImgAlt: "Dynamic Email",
            cardTagText1: "Dynamic Email",
            cardHeadingText1: "Dynamic approvals",
            cardDescText1: "Let each person filling out your form assign their submission to a specific approver. Users can type the email address field on the form, ensuring that each submission goes to the right approver without requiring any extra work on the backend.",
            cardBtnText2: "Try For Free!",
            cardClassName: "".concat((features_module_default()).card_mt_1, " pb-10 xs:pb-40 md:pb-0"),
            bgImgSrc: "".concat(constants.BASE_ASSETS_URL, "/features/bg_1.svg"),
            bgContainerStyles: {
                bottom: "-200px"
            },
            bgImgStyles: {
                transform: "scaleX(-1)"
            },
            bgClassNameContainer: "bottom-[-100px!important] lg:bottom-[-200px!important] xl:bottom-[-250px!important] xxl:bottom-[-300px!important]"
        },
        {
            featuresContainerStyles: "mt-20 lg:mt-40",
            cardImgSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/11.png",
            cardImgAlt: "Export Reports",
            cardTagText1: "Reports",
            cardHeadingText1: "Download Approval Reports",
            cardDescText1: "Create custom CSV reports to track and summarize your approval history. It’s an easy way to view and document all of the actions taken throughout the approval process.",
            cardBtnText2: "Try For Free!",
            cardRowReverse: true,
            cardClassName: "mt-20 sm:mt-40",
            bgImgSrc: "".concat(constants.BASE_ASSETS_URL, "/features/bg_1.svg"),
            bgUpSideDown: true,
            bgContainerStyles: {
                top: "0px"
            },
            bgImgStyles: {
                transform: "scaleX(-1)"
            }
        },
        {
            featuresContainerStyles: "flex-col mt-20 sm:mt-40",
            preCardJsx: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full flex flex-col justify-center items-center mt-20 md:-mt-12 lg:mt-0 xl:mt-10 xxl:mt-20 min-[1700px]:mt-44 mb-20 sm:mb-60",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-2xl md:text-3xl xl:text-4xl text-white text-center font-semibold mt-4",
                        children: "Set up advanced conditional logic"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-base md:text-lg mt-3 text-white text-center w-full ",
                        children: "Make sure your tasks are forwarded to the right people with custom approval flow conditions."
                    })
                ]
            }),
            cardImgSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/10.png",
            cardImgAlt: "Conditional Logic",
            cardTagText1: "Conditional Logic",
            cardHeadingText1: "Use if-else conditions",
            cardDescText1: "Conditionally route requests to the right approver with our if-else feature. For example, if an expense request over $500 is approved by a finance specialist, you can forward it to your finance manager automatically.",
            cardHeadingText2: "Add multiple approvers",
            cardDescText2: "Multiple people have permissions to approve a request and if any one of them approves the request, it is sent to the next step.",
            cardStyles: {
                marginTop: "0px"
            },
            bgImgSrc: "".concat(constants.BASE_ASSETS_URL, "/features/bg_2.svg"),
            bgContainerStyles: {
                top: "-200px"
            },
            bgImgStyles: {
                transform: "scaleX(1.5)"
            },
            bgClassNameContainer: (features_module_default()).bg_container_1,
            bgClassNameImg: (features_module_default()).bg_img_1
        },
        // {
        //   featuresContainerStyles: "mt-52",
        //   cardImgSrc: i13,
        //   cardTagText1: "Merge Parallel Paths",
        //   cardHeadingText1: "Combine different paths in your approval flow.",
        //   cardHeadingText2: "All",
        //   cardDescText2:
        //     "Complete tasks in all branches before moving to the next step.",
        //   cardHeadingText3: "Any",
        //   cardDescText3:
        //     "Complete tasks in any branch before moving to the next step.",
        //   cardRowReverse: true,
        //   cardStyles: { marginTop: "250px" },
        //   cardClassName: styles.card_mt_1,
        //   bgImgSrc: `${BASE_ASSETS_URL}/features/bg_7.svg`,
        //   bgContainerStyles: { top: "-150px", right: "0px" },
        // },
        // {
        //   featuresContainerStyles: "mt-52",
        //   cardImgSrc: i14,
        //   cardTagText1: "My Approvals",
        //   cardHeadingText1: "My Approvals",
        //   cardDescText1:
        //     "Approvers can view all of their tasks n the BoloForms Approver Dashboard.",
        //   cardBtnText2: "Try For Free!",
        //   cardStyles: { marginTop: "300px" },
        //   cardClassName: styles.card_mt_1,
        //   bgImgSrc: `${BASE_ASSETS_URL}/features/bg_7.svg`,
        //   bgContainerStyles: { top: "-150px", right: "0px" },
        //   bgImgStyles: {
        //     transform: "scaleX(-1)",
        //   },
        // },
        {
            featuresContainerStyles: "mt",
            cardImgSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/9.png",
            cardImgAlt: "Process Management",
            cardTagText1: "Process Management",
            cardHeadingText1: "Track & Manage Processes",
            cardDescText1: "Track your approval flows in multiple ways on any device. Complete tasts via email, BoloForms Dashboard, and WhatsApp.",
            cardRowReverse: true,
            cardClassName: "mt-20 sm:mt-40 mb-5 sm:mb-20 md:mb-0",
            bgImgSrc: "".concat(constants.BASE_ASSETS_URL, "/features/bg_1.svg"),
            bgContainerStyles: {
                bottom: "-190px"
            }
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: " Approvals Features Signature | BoloForms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Boloforms helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/features"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/features"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Approvals Features Signature | BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/features"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "Boloforms helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: "Boloforms helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    })
                ]
            }),
            features.map((feature, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full relative flex justify-center items-center ".concat(feature.featuresContainerStyles),
                    children: [
                        feature.preCardJsx && feature.preCardJsx,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesCards, {
                            ...feature
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesBackground, {
                            ...feature
                        })
                    ]
                }, index)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[calc(100%_+_32px)] xs:w-[calc(100%_+_48px)] lg:w-[calc(100%_+_176px)] xxl:w-[calc(100%_+_256px)] -translate-x-4 xs:-translate-x-6 lg:-translate-x-[88px] xxl:-translate-x-[128px] relative flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full bg-[#ad84ff] relative flex flex-col justify-center items-center mt-40 sm:mt-36 py-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-3xl md:text-4xl text-center text-white font-semibold px-6 mt-4",
                            children: "Create automated approval flows with BoloForms"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full flex flex-col md:flex-row justify-center items-center gap-5 mt-10 px-4 xs:px-6 md:mt-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                target: "_blank",
                                href: "https://approval-dashboard.boloforms.com/login",
                                className: "w-full md:w-fit text-lg font-medium text-center px-6 py-2 rounded-lg bg-white text-[#915bff] hover:opacity-90 transition-colors",
                                children: "Try for Free"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "w-full absolute bg-[#ad84ff] h-40 -bottom-40 -z-10"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var features = (Features);


/***/ }),

/***/ 21167:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_1":"features_section_1__SJRFL","section_mt_1":"features_section_mt_1__O2tx8","card_mt_1":"features_card_mt_1__lAYiv","bg_container_1":"features_bg_container_1__tiVbU","bg_container_2":"features_bg_container_2__yltnl","bg_container_3":"features_bg_container_3__fv5Eu","bg_img_1":"features_bg_img_1____DgO"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(57808); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);